export default 'NOTIFICATIONS';
